import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="py-24 bg-[#FDFCF7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="romano-badge mb-4 inline-block">Testimonials</span>
          <h2 className="romano-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#622B62] mb-4">
            What Our Customers Say
          </h2>
          <div className="section-divider mx-auto mb-6" />
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers
            have to say about our services.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="testimonial-card bg-white rounded-2xl p-8 shadow-lg relative"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 right-8">
                <div className="w-10 h-10 rounded-full bg-[#DA9C3A] flex items-center justify-center shadow-lg">
                  <Quote size={18} className="text-white" />
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    size={18}
                    className="text-[#DA9C3A] fill-[#DA9C3A]"
                  />
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-600 leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-14 h-14 rounded-full object-cover border-3 border-[#DA9C3A]/20"
                />
                <div>
                  <h4 className="font-bold text-[#622B62]">{testimonial.name}</h4>
                  <p className="text-gray-500 text-sm">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 text-center">
          <p className="text-gray-500 mb-6">Trusted by homeowners across the region</p>
          <div className="flex flex-wrap justify-center items-center gap-8">
            <div className="flex items-center gap-2">
              <div className="flex -space-x-2">
                {[...Array(4)].map((_, i) => (
                  <div
                    key={i}
                    className="w-10 h-10 rounded-full bg-[#622B62] border-2 border-white flex items-center justify-center"
                  >
                    <Star size={14} className="text-[#DA9C3A] fill-[#DA9C3A]" />
                  </div>
                ))}
              </div>
              <div className="ml-2">
                <p className="font-bold text-[#622B62]">4.9 / 5</p>
                <p className="text-xs text-gray-500">Average Rating</p>
              </div>
            </div>
            <div className="h-10 w-px bg-gray-300 hidden sm:block" />
            <div>
              <p className="font-bold text-[#622B62]">5000+</p>
              <p className="text-xs text-gray-500">Happy Customers</p>
            </div>
            <div className="h-10 w-px bg-gray-300 hidden sm:block" />
            <div>
              <p className="font-bold text-[#622B62]">100%</p>
              <p className="text-xs text-gray-500">Satisfaction Rate</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
